import * as Swal from "sweetalert2";

(function ($) {
    function Common() {
        this.body = $('html, body');
        this._enrollBtn = null;
        this._popupAddedToCart = null;
        this._popupLogin = null;
        this._popupSignup = null;
        this.pageLoader = $("#page-loader");

        this.courseType = null;
        this.selectedCourseId = null;
        this.selectedLocation = null;

        this.init();
        this.addListeners();
    }

    Common.prototype = {
        constructor: Common,

        init: function () {
            let self = this;

            self._enrollBtn = $('.enroll');
            self._popupAddedToCart = $('#popup--add-to-cart');
            self._popupLogin = $('#loginFormModal');
            self._popupSignup = $('#signUpFormModal');

            self.registerCourseLiveBtn = $(".registration-course-live-btn");
            self.registerConferenceBtn = $(".conference-registration-btn")
        },

        addListeners: function () {
            const self = this;

            $('body').delegate('.enroll', 'click', function (event) {
                event.preventDefault();

                self.courseType = 'on-demand';
                self.selectedCourseId = $(this).data('id');
                self.selectedLocation = null;

                self.handleAddToCart($(this));
            });

            self._popupAddedToCart.find('button.close').on('click', function (event) {
                event.preventDefault();
                self._popupAddedToCart.removeAttr('style');
            });

            self.registerCourseLiveBtn.on('click', function (e) {
                e.preventDefault();

                self.courseType = $(this).data('type') ? $(this).data('type') : 'live';
                self.selectedCourseId = $(this).data('id');
                self.selectedLocation = $(this).data('location');

                self.isLogin()
                    .then(function (is_login) {
                        if (!is_login) {
                            self._popupSignup.modal('show');
                        } else {
                            self.registerCourseAfterAuth();
                        }
                    });
            });

            self.registerConferenceBtn.on('click', function (event) {
                event.preventDefault();

                self.courseType = 'conference';
            });

            self._popupLogin.on('show.bs.modal', function () {
                self._popupSignup.modal('hide');

                if (!self.body.hasClass('modal-open')) {
                    self.body.addClass('modal-open');
                }
            });

            self._popupSignup.on('show.bs.modal', function () {
                self._popupLogin.modal('hide');
                if (!self.body.hasClass('modal-open')) {
                    self.body.addClass('modal-open');
                }
            });

            self._popupLogin.on('hide.bs.modal', function () {
                self.body.removeClass('modal-open');
            });

            self._popupSignup.on('hide.bs.modal', function () {
                self.body.removeClass('modal-open');
            });

            self._popupLogin.find('form').submit(function (e) {
                e.preventDefault();

                if (self.courseType != 'conference') {
                    self.handleSubmitLoginModal();
                }
            });

            self._popupSignup.find('form').submit(function (e) {
                e.preventDefault();

                if (self.courseType != 'conference') {
                    self.handleSubmitRegisterModal();
                }
            });
        },

        handleAddToCart($btn) {
            const self = this;

            let course_id = $btn.data('id'),
                cartBtn = $('.cart-button[data-id=' + course_id + ']');

            if ($btn.attr('href') === '#pricing-location') {
                const windowWidth = $(window).width();
                const scrollOffset = windowWidth > 1366 ? 150 : (windowWidth > 417 ? 230 : 250);

                self.body.animate({
                    scrollTop: $('#pricing-location').offset().top - scrollOffset
                }, 300);

                return false;
            } else if ($btn.attr('href') !== 'javascript:void(0);') {
                window.location.href = $btn.attr('href');

                return false;
            }

            if (!$btn.hasClass('enroll')) {
                return false;
            }

            $.ajax({
                url: pageData.routes.add_to_cart,
                type: 'POST',
                data: { course_id: course_id, _token: pageData.csrf_token },
                beforeSend: function() {
                    $btn.addClass('loader').attr('disabled', true);
                },
                success: function(response) {
                    if (response.success) {
                        if (response.is_mobile) {
                            if (response.count_item) {
                                $('#miniCartDropDownMobile .badge').text(response.count_item);
                            } else {
                                $('#miniCartDropDownMobile .badge').remove();
                            }

                            $('#cart-menu .mini-cart-item-mobile').html(response.cart_html);
                        } else {
                            $('.dropdown.mini-cart-item').html(response.cart_html);
                        }

                        cartBtn.html("<i class='la la-check-circle'></i> Added In Cart");
                        cartBtn.removeClass('enroll');

                        if (undefined !== response.popup_content) {
                            self._popupAddedToCart.find('.modal-body').empty().html(response.popup_content);
                            self._popupAddedToCart.css({'display': 'flex'});
                        }
                    } else if (response.message) {
                        $btn.removeClass('loader').removeAttr('disabled');
                        Swal.fire({
                            icon: 'warning',
                            title: response.message,
                            confirmButtonText: "OK"
                        });
                    } else if (!response.is_login) {
                        self._popupSignup.modal('show');
                    } else {
                        $btn.removeClass('loader').removeAttr('disabled');
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    $btn.removeClass('loader').removeAttr('disabled');
                    alert(errorThrown);
                },
                complete: function() {
                    $btn.removeClass('loader').removeAttr('disabled');
                }
            });
        },

        handleSubmitLoginModal() {
            const self = this;
            const loginForm = self._popupLogin.find('form');
            const submitButton = loginForm.find('button[type=submit]');
            const alertError = self._popupLogin.find('.alert-error');

            self.recaptchaChallenge('login_ajax', function (gRecaptchaResponse) {
                const postData = new FormData(loginForm.get(0));
                postData.append('g-recaptcha-response', gRecaptchaResponse);

                $.ajax({
                    url: pageData.routes.login_ajax,
                    type: 'POST',
                    data: postData,
                    contentType: false,
                    processData: false,
                    dataType: 'json',
                    beforeSend: function() {
                        self.hideSubmitError(alertError);
                        self.pageLoader.css("display", "flex");
                        submitButton.prop('disabled', true);
                    },
                    success: function(response) {
                        if (!response.success) {
                            self.showSubmitError(alertError, response.error);

                            return false;
                        }

                        pageData.csrf_token = response._t;

                        self.registerCourseAfterAuth();
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        alert(errorThrown);
                    },
                    complete: function() {
                        self.pageLoader.hide();
                        submitButton.prop('disabled', false);
                    }
                });
            });
        },

        handleSubmitRegisterModal() {
            const self = this;
            const registerForm = self._popupSignup.find('form');
            const submitButton = registerForm.find('button[type=submit]');
            const alertError = self._popupSignup.find('.alert-error');

            const submitData = new FormData(registerForm.get(0));
            submitData.append('registering_course', self.selectedCourseId);

            self.recaptchaChallenge('regiser_ajax', function (gRecaptchaResponse) {
                submitData.append('g-recaptcha-response', gRecaptchaResponse);

                $.ajax({
                    url: pageData.routes.register_ajax,
                    type: 'POST',
                    data: submitData,
                    contentType: false,
                    processData: false,
                    dataType: 'json',
                    beforeSend: function() {
                        self.hideSubmitError(alertError);
                        self.pageLoader.css("display", "flex");
                        submitButton.prop('disabled', true);
                    },
                    success: function(response) {
                        if (!response.success) {
                            self.showSubmitError(alertError, response.error);

                            return false;
                        }

                        pageData.csrf_token = response._t;

                        self.registerCourseAfterAuth();
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        alert(errorThrown);
                    },
                    complete: function() {
                        self.pageLoader.hide();
                        submitButton.prop('disabled', false);
                    }
                });
            });
        },

        registerCourseAfterAuth() {
            if (this.courseType === 'live') {
                window.location.href = pageData.home_url + '/courses/live-course-register/' + this.selectedCourseId + '/' + this.selectedLocation
            } else if (this.courseType === 'conference') {
                window.location.href = pageData.home_url + '/conference/registration/' + this.selectedCourseId + '/' + this.selectedLocation
            } else {
                this.addToCartAfterAuth();
            }
        },

        addToCartAfterAuth() {
            const self = this;

            $.ajax({
                url: pageData.routes.add_to_cart,
                type: 'POST',
                data: {
                    course_id: self.selectedCourseId,
                    _token: pageData.csrf_token
                },
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        window.location.href = pageData.routes.checkout
                    } else if (response.message) {
                        Swal.fire({
                            icon: 'warning',
                            title: response.message,
                            confirmButtonText: "OK"
                        });
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    alert(errorThrown);
                },
            });
        },

        isLogin() {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: pageData.routes.me_ajax,
                    type: 'POST',
                    data: {
                        _token: pageData.csrf_token
                    },
                    dataType: 'json',
                    success: function(response) {
                        resolve(response.is_login)
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        reject(errorThrown);
                    },
                });
            })
        },

        recaptchaChallenge(action, callback) {
            grecaptcha.execute(pageData.recaptcha_sitekey, {action: action}).then(function(token) {
                callback(token);
            });
        },

        showSubmitError(alert, message) {
            alert.find(".error-message").html(message);
            alert.fadeIn();
        },

        hideSubmitError(alert) {
            alert.hide();
        },
    }

    $(document).ready(function () {
        new Common();
    })
}) (jQuery)
